"use strict";

export default class SignupController {
  //start-non-standard
  user = {
    email: "",
    password: "",
    confirmPassword: "",
  };
  errors = {};
  submitted = false;
  //end-non-standard

  constructor(Auth, $state, LanguageService, PasswordService) {
    "ngInject";
    this.Auth = Auth;
    this.$state = $state;
    this.ls = LanguageService;
    this.getStrength = PasswordService.getStrength;
  }

  register(form) {
    this.submitted = true;

    if (form.$valid) {
      this.Auth.createUser({
        //alias: this.user.alias,
        email: this.user.email,
        password: this.user.password,
      })
        .then(() => {
          // Account created, redirect to home
          this.$state.go("permission");
        })
        .catch((err) => {
          err = err.data;
          this.errors = {};
          // Update validity of form fields that match the sequelize errors
          if (err.name == "dal-error") {
            for (var fname in err.fields) {
              if (err.fields.hasOwnProperty(fname)) {
                form[fname].$setValidity("mongoose", false);
                this.errors[fname] = this.ls.lang == "fr" ? err.fr : err.en;
              }
            }
          } else {
            for (var fname in err.fields) {
              if (err.fields.hasOwnProperty(fname)) {
                form[fname].$setValidity("mongoose", false);
                this.errors[fname] = err.message;
              }
            }
          }
        });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/signup/signup.controller.js